module.exports = __webpack_public_path__ + "static/media/sales.64e5a922.svg";